/* Storefront courtesy limit only. Shopify server-side validation is still required for enforcement. */
(function(){
 'use strict';
 if(window.XDropGiftLimit)return;
 const variants=new Set(['50859393613872','50859956502576']);
 const products=new Set(['10334243749936','10334369841200']);
 const original=window.fetch.bind(window),root=window.Shopify?.routes?.root||'/';
 let queue=Promise.resolve(),bypassForm=null;
 const gift=i=>variants.has(String(i.variant_id||i.id))||products.has(String(i.product_id));
 const message=()=>document.documentElement.lang.startsWith('es')?'Máximo una caja gratuita por pedido. Puedes eliminar la actual para elegir otra.':'Maximum one free box per order. Remove the current one to choose another.';
 const serial=fn=>{const next=queue.then(fn,fn);queue=next.catch(()=>{});return next;};
 async function getCart(){const r=await original(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});if(!r.ok)throw Error('Unable to verify cart');return r.json();}
 async function normalize(){
   let cart=await getCart(),kept=false;
   for(const item of cart.items){if(!gift(item))continue;const quantity=kept?0:Math.min(1,item.quantity);kept=true;
     if(item.quantity!==quantity){const r=await original(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:item.key,quantity})});if(!r.ok)throw Error('Unable to verify free box limit');cart=await r.json();}
   }
   return cart;
 }
 function parseBody(body){
   if(typeof body==='string'){try{return {kind:'json',data:JSON.parse(body)};}catch(_){return {kind:'params',data:new URLSearchParams(body)};}}
   if(body instanceof FormData)return {kind:'form',data:new FormDataClone(body)};
   if(body instanceof URLSearchParams)return {kind:'params',data:new URLSearchParams(body)};
   return null;
 }
 function FormDataClone(source){const result=new FormData();for(const [k,v] of source.entries())result.append(k,v);return result;}
 async function guardAdd(init){
   const parsed=parseBody(init.body);if(!parsed)throw Error('Cannot verify gift request');
   let occupied=(await getCart()).items.some(gift);
   const accept=item=>{if(!variants.has(String(item.id)))return true;if(occupied)return false;occupied=true;item.quantity=1;return true;};
   if(parsed.kind==='json'){
     const data=parsed.data;
     if(Array.isArray(data.items)){data.items=data.items.filter(accept);if(!data.items.length)return null;}
     else if(!accept(data))return null;
     return {...init,body:JSON.stringify(data)};
   }
   const data=parsed.data,id=data.get('id');
   // Bracket-array forms cannot be safely transformed here. Fail closed rather than add an unchecked gift.
   if(!id){throw Error('Unsupported cart form; use individual product buttons');}
   if(variants.has(String(id))){if(occupied)return null;data.set('quantity','1');}
   return {...init,body:data};
 }
 function rejection(description){return new Response(JSON.stringify({status:422,message:description,description}),{status:422,headers:{'Content-Type':'application/json'}});}
 window.fetch=function(input,init){
   let u;try{u=new URL(typeof input==='string'||input instanceof URL?input:input.url,location.href);}catch(_){return original(input,init);}
   const match=u.pathname.match(/\/cart\/(add|change|update)(?:\.js)?$/);
   if(u.origin!==location.origin||!match)return original(input,init);
   const method=(init?.method||(input instanceof Request?input.method:'GET')).toUpperCase();if(method!=='POST')return original(input,init);
   return serial(async()=>{
     let options={...(init||{})};
     if(input instanceof Request){options={method:input.method,headers:new Headers(input.headers),credentials:input.credentials,...options};if(options.body===undefined)options.body=await input.clone().text();}
     if(match[1]==='add'){try{options=await guardAdd(options);}catch(error){return rejection(error.message);}if(!options)return rejection(message());}
     const response=await original(u.href,options);if(!response.ok)return response;
     const cart=await normalize();
     if(match[1]!=='add')return new Response(JSON.stringify(cart),{status:200,headers:{'Content-Type':'application/json'}});
     return response;
   });
 };
 async function checkout(form,button){
   await serial(normalize);
   // Native submit must not re-send old line-index quantities after duplicate lines were removed.
   form.querySelectorAll('[name="updates[]"], [name^="updates["]').forEach(i=>i.disabled=true);
   bypassForm=form;try{form.requestSubmit(button||undefined);}finally{bypassForm=null;}
 }
 document.addEventListener('submit',async event=>{
   const form=event.target;if(!(form instanceof HTMLFormElement)||bypassForm===form)return;
   const u=new URL(form.action||location.href,location.href);if(u.origin!==location.origin)return;
   const isCart=/\/cart\/?$/.test(u.pathname),isAdd=/\/cart\/add(?:\.js)?$/.test(u.pathname);
   if(!isCart&&!isAdd)return;
   const data=new FormData(form),button=event.submitter;
   if(isAdd&&!variants.has(String(data.get('id'))))return;
   // Existing custom AJAX handlers use the guarded fetch path; avoid a second add.
   if(isAdd && (form.id==='kg-buy-form'||form.closest('product-form')))return;
   event.preventDefault();event.stopImmediatePropagation();
   try{
     if(isAdd){const r=await window.fetch(root+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});if(!r.ok){const err=await r.json();throw Error(err.description||message());}location.assign(root+'cart'+location.search);return;}
     // Apply legitimate quantity edits first; the fetch guard then clamps gifts only.
     const r=await window.fetch(root+'cart/update.js',{method:'POST',body:data,headers:{Accept:'application/json'}});if(!r.ok)throw Error('Unable to update cart');
     if(button?.name==='checkout')await checkout(form,button);else location.reload();
   }catch(error){alert(error.message||message());}
 },true);
 // Non-form checkout links must also pass validation.
 document.addEventListener('click',event=>{
   const a=event.target.closest?.('a[href]');if(!a)return;const u=new URL(a.href,location.href);
   if(u.origin!==location.origin||!/^\/checkout\/?$/.test(u.pathname))return;
   event.preventDefault();serial(normalize).then(()=>location.assign(a.href)).catch(error=>alert(error.message));
 },true);
 window.XDropGiftLimit={normalize:()=>serial(normalize),variants:[...variants]};
})();
